import React from "react";
import ContactUsForm from "../components/ContactUsForm";
import Footer from "../components/Footer";
import NavBar from "../components/NavBar";

const ContactUs = () => {
    return(
        <div>
            <NavBar/>
            <ContactUsForm/>
            <Footer/>
        </div>
    )
}

export default ContactUs;